export default {
    name: 'remuneration_overview_resource',
    definition: {
        remuneration_lines: '',
        expand_with: '',
        group_by: '',
        detail_line: '',
        date_filter: '',
        employee_filter: '',
        insurer_filter: '',
        location_filter: '',
    },
    options: {
        collectionPath: 'remuneration_resources',
    },
};
